module.exports = __webpack_public_path__ + "src/assets/games/43/99.jpg";